import * as React from "react"
import { cn } from "../../utils/helpers"
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "./tooltip"

export interface TextAreaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    tooltipText?: React.ReactNode;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(({ className, tooltipText, style, ...props }, ref) => {

    const textareaElement = (
        <textarea
            className={cn(
               "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base text-foreground shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
                className
            )}
            style={{ resize: "vertical", color: "var(--foreground)", ...style }}
            ref={ref}
            {...props}
        />
    );

    if (!tooltipText) return textareaElement;

    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>{textareaElement}</TooltipTrigger>
                <TooltipContent side="top" align="end" sideOffset={0} className="z-[1400]">
                    {tooltipText}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
})
TextArea.displayName = "TextArea"

export { TextArea }